var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50894 20.8678C3.42901 21.4673 3.89538 22 4.50017 22H6.35798C6.35995 22 6.36157 22.0016 6.36167 22.0035C6.43787 23.5135 7.68626 24.7143 9.21513 24.7143C10.4153 24.7143 11.4426 23.9743 11.8658 22.9257C12.0653 22.4312 12.4876 22 13.0207 22H20.8382C21.3714 22 21.7937 22.4312 21.9932 22.9257C22.4163 23.9743 23.4437 24.7143 24.6438 24.7143C25.844 24.7143 26.8714 23.9743 27.2945 22.9257C27.494 22.4312 27.9163 22 28.4494 22H28.4907C28.9883 22 29.4103 21.6341 29.4806 21.1414L30.3078 15.3515C30.3403 15.1241 30.2935 14.8925 30.1753 14.6956L27.6493 10.4855C27.4686 10.1843 27.1431 10 26.7918 10H22.0384C21.4205 10 20.9505 9.44513 21.052 8.8356L21.1639 8.1644C21.2655 7.55487 20.7955 7 20.1775 7H6.2335C5.7323 7 5.30851 7.37103 5.24227 7.86784L3.50894 20.8678Z",
    fill: "#F5DADF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.7859,
    cy: 21.8571,
    r: 2.85714,
    stroke: "#2D2926",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.35714,
    cy: 21.8571,
    r: 2.85714,
    stroke: "#2D2926",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16H7.78571",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11H11.5",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64355 7H17.0748C19.494 7 21.3595 9.13072 21.0397 11.5287L19.6436 22H12.5M3.64355 22H6.5",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.8571H19.5L21.2143 10H25.2691C26.6558 10 27.9436 10.7182 28.6723 11.898L30.3096 14.5489C30.4326 14.7481 30.4819 14.9841 30.4488 15.2158L29.5 21.8571H27.5",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.f3c546c2783a587a72353ae81b24ca2e.svg";
export { ForwardRef as ReactComponent };